// src/services/searchService.ts
import { apiService } from './api';
import { getPeopleOnLine } from '../lib/peopleOnlineStatus';

export interface SearchResultItem {
  ID: number;
  Name: string;
  ImageName: string | null;
  isOnLine: boolean;
  Type: string;
  TypeId: number;
  Icon: string;
  ProjectId: number | null;
  ProjectName: string | null;
  IsDashboardsFilter: boolean;
}

class SearchService
{
  async search(searchText: string): Promise<SearchResultItem[]>
  {
    try
    {
      const response = await apiService.get<SearchResultItem[]>(
        `project/Search?searchText=${encodeURIComponent(searchText)}`,
      );
      // The API computes isOnLine once per request, so it's stale for anyone who
      // connected/disconnected since — overlay the live socket-tracked status.
      return getPeopleOnLine(response);
    }
    catch (error)
    {
      console.error('Error searching:', error);
      return [];
    }
  }
}

export const searchService = new SearchService();
